export default {
  computed: {
    definitions() {
      if (!Array.isArray(this.settings.definitions)) {
        return []
      }

      return this.settings.definitions
        .filter(definition => !!definition.title && !!definition.content)
        .map(definition => ({
          key: `definition-${Math.random().toString().replace('.', '_')}`,
          title: definition.title || '',
          content: definition.content || '',
        }))
    },
  },
}
